export default {
    connectedInstagramAccounts(state) {
        return state.connectedInstagramAccounts;
    },
    instagramKeywords(state) {
        return state.instagramKeywords;
    },
    connectedInstagramAccountsForSelect(state) {
        const accounts = [];
        
        for (const index in state.connectedInstagramAccounts) {
            const keywordItem = {
                id: state.connectedInstagramAccounts[index].id,
                text: state.connectedInstagramAccounts[index].feederName
            }

            accounts.push(keywordItem);
        }

        return accounts;
    },
    instagramAccounts(state){
        return state.instagramAccounts;
    }
}